<sh-card
    label="{{ label() | translate }}"
    [icon]="icon()"
    [attr.href]="externalLink() ?? link()"
    [attr.data-testid]="testId() ?? null"
    class="w-full aspect-square cursor-pointer"
>
    <div slot="footer" class="h-8">
        <sh-text class="text-center">{{ description() | translate }}</sh-text>
    </div>
</sh-card>
